export default [
  {
    path: 'detectionRecord',
    name: 'cottonBaleDetectionRecord',
    component: () => import('@/views/cotton/record/cottonBaleDetection/index.vue'),
    props: true,
    meta: {
      hidden: true,
      noPadding: true
    }
  },
  {
    path: 'alarmRecord',
    name: 'cottonBaleAlarmRecord',
    component: () => import('@/views/cotton/record/cottonBaleAlarm/index.vue'),
    props: true,
    meta: {
      hidden: true,
      noPadding: true
    }
  },
  {
    path: 'inspectionRecord',
    name: 'cottonBaleInspectionRecord',
    component: () => import('@/views/cotton/record/cottonBaleInspection/index.vue'),
    props: true,
    meta: {
      hidden: true,
      noPadding: true
    }
  }
];
